import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-semibold mb-3">
              热门榜单
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              实时热度PK排行榜
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3">
              基于真实投票数据的热度排名，数据每30分钟更新一次，去水靠真热度
            </p>
          </div>

          <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
            {rankingData.map((item, index) => (
              <div
                key={item.rank}
                className={`flex items-center gap-4 p-4 md:p-5 ${
                  index < rankingData.length - 1 ? 'border-b border-background-200/50' : ''
                } hover:bg-background-100 transition-colors cursor-pointer`}
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-secondary-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-400 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                </div>

                <div className="flex items-center gap-3 flex-shrink-0">
                  <div className="text-right">
                    <div className="text-sm font-bold text-foreground-900 font-heading">{item.votes}</div>
                    <div className="text-xs text-foreground-500">总票数</div>
                  </div>
                  <span className={`flex items-center gap-0.5 text-xs font-semibold whitespace-nowrap ${
                    item.trend === 'up' ? 'text-primary-500' : 'text-foreground-500'
                  }`}>
                    <i className={`${item.trend === 'up' ? 'ri-arrow-up-s-fill' : 'ri-arrow-down-s-fill'} text-xs`}></i>
                    {item.change}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}